module.exports = __webpack_public_path__ + "img/class.ed685a70.png";